import { useQuery } from '@tanstack/react-query';
import { size } from 'lodash';
import { useEffect } from 'react';
import getInvoices from '../../api/queries/getInvoices';
import { selectUser } from '../../redux/auth/authSlice';
import { selectInvoices, setInvoices } from '../../redux/data/dataSlice';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

const useData = () => {
  const user = useAppSelector(selectUser);
  const invoices = useAppSelector(selectInvoices);

  const { data, isLoading, isStale, isSuccess, error, refetch } = useQuery({
    queryKey: ['getInvoices'],
    enabled: !!user && size(invoices) == 0,
    queryFn: () => getInvoices(),
  });

  return {
    data,
    isLoading,
    isStale,
    isSuccess,
    error: error,
    refetch,
  };
};

const useInovoicesStoreSetter = () => {
  const { data, refetch, isLoading, isStale, isSuccess } = useData();
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (data && isSuccess && isStale) {
      dispatch(setInvoices(data));
    }
  }, [dispatch, isSuccess, isStale, data]);

  return { data, isLoading, refetch };
};

export { useInovoicesStoreSetter };
